import React from 'react'

export interface MultipleRadioInputOpt<T> {
    label: string | React.ReactNode;
    name: string;
    value: T;
    showSelectionNote?: string
  }

interface Props<T> {
  legendLabel?: string;
  options: MultipleRadioInputOpt<T>[];
  value: T;
  changeHandler: React.ChangeEventHandler<HTMLInputElement>;
  labelIcon?: JSX.Element;
  disabled?: boolean;
}

export function MultipleRadioInput<T extends string | number | readonly string[] | boolean | undefined> (props: Props<T>): React.ReactElement {
  const { disabled = false } = props

  const showNote = (option: MultipleRadioInputOpt<T>): JSX.Element | null => {
    if (props.value !== option.value || !option?.showSelectionNote) {
      return null
    }

    return (
      <small className="selection-note">
        {option.showSelectionNote}
      </small>
    )
  }

  return (
    <div className={'setting-radio-button'}>
      <legend className={'label message-input legend-label'}>
        {props.legendLabel}
        {props.labelIcon}
      </legend>
      {props.options.map((option, key) => (
        <div key={key} className={'radio-option'}>
          <input
            key={key}
            type={'radio'}
            name={option.name}
            id={`${option.name}-${key}`}
            value={option.value}
            checked={props.value === option.value}
            onChange={props.changeHandler}
            disabled={disabled}
          />
          <label htmlFor={`${option.name}-${key}`}>
            {/* eslint-disable-next-line no-mixed-operators */}
            {option.label}
            {' '}
            {showNote(option)}

          </label>
      </div>
      ))}
    </div>
  )
}
